import { get, httpDelete, patch, post } from '../../utils/http';

export const fetchPosts = ({ accountId, projectId, branches, token, search }) =>
  get(`/accounts/${accountId}/posts`, { search, projectId, branches, pageSize: 20, token: token || 0 });

export const addPost = ({ accountId, branches, ...params }) =>
  post(`/accounts/${accountId}/posts`, { branches, ...params });

export const fetchPost = ({ accountId, postId }) => get(`/accounts/${accountId}/posts/${postId}`);

export const editPost = ({ accountId, id: postId, ...params }) =>
  patch(`/accounts/${accountId}/posts/${postId}`, params);

export const deletePost = ({ accountId, id: postId }) => httpDelete(`/accounts/${accountId}/posts/${postId}`);
